import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AdminSection from '../components/AdminSection';
import CountdownTimer from '../components/CountdownTimer';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      
      <main className="flex-1 pt-14">
        <HeroSection />
        <CountdownTimer />
        <AdminSection />
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
